import { render } from "./GuidedArrow.vue?vue&type=template&id=00d4a9e4&scoped=true"
import script from "./GuidedArrow.vue?vue&type=script&lang=js"
export * from "./GuidedArrow.vue?vue&type=script&lang=js"

import "./GuidedArrow.vue?vue&type=style&index=0&id=00d4a9e4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d4a9e4"]])

export default __exports__